import { AppLandingPage } from "../operations/app-landing-page";
import { WishingTreePage } from "../operations/wishing-tree-page";
import { NewFaiChunPage } from "../operations/new-fai-chun-page";
import { Newspaper } from "@mui/icons-material";

const routes = [
  {
    name: "AppLandingPage",
    key: "app-landing",
    icon: <Newspaper />,
    route: "/",
    routeNav: "/",
    component: <AppLandingPage />,
  },
  {
    name: "WishingTreePage",
    key: "wishing-tree-page",
    icon: <Newspaper />,
    route: "/wishing-tree/:roomId",
    routeNav: "/wishing-tree",
    component: <WishingTreePage />,
  },
  {
    name: "Container",
    key: "fai-chun-page",
    icon: <Newspaper />,
    route: "/fai-chun/:roomId",
    routeNav: "/fai-chun",
    component: <NewFaiChunPage />,
  },
  // {
  //   name: "Container",
  //   key: "app-container",
  //   icon: <Newspaper />,
  //   route: "/operations/app-container",
  //   component: <AppContainer />,
  // },
];

export default routes;
